import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Avatar.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "outer", style: "zIndex: " + _vm.zIndex },
    [
      _vm._t("avatar-header"),
      _vm._v(" "),
      _c(
        _vm.tag,
        {
          tag: "component",
          staticClass: "wrapper",
          style: _vm.style,
          attrs: { href: _vm.link, target: "_blank", size: _vm.size }
        },
        [
          _vm.avatar && !_vm.error
            ? _c("img", {
                attrs: { draggable: "false", src: _vm.avatar, alt: "avatar" },
                on: {
                  error: function($event) {
                    _vm.error = true;
                  }
                }
              })
            : _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 128 128",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("g", [
                    _c("circle", {
                      attrs: {
                        cx: "64",
                        cy: "64",
                        r: "64",
                        fill: "rgb(193, 199, 208)"
                      }
                    }),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        attrs: {
                          d:
                            "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
                        }
                      })
                    ])
                  ])
                ]
              ),
          _vm._v(" "),
          _vm.status
            ? _c(_vm.status, {
                tag: "component",
                staticClass: "status",
                attrs: { size: _vm.size }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.presence
            ? _c(_vm.presence, {
                tag: "component",
                staticClass: "presence",
                attrs: { size: _vm.size, "primary-color": "green" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("avatar-footer")
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-a4a77c76";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Avatar/Avatar.vue.js